module.exports = __webpack_public_path__ + "img/cost-icon__cowork.83a54794.svg";